<template>
    <div>
        <!-- Alert errori -->
        <div v-if="errors" class="alert alert-danger alert-dismissible fade show" role="alert">
            <ul class="mb-0">
                <li v-for="(msg, field) in errors" :key="field">{{ msg[0] }}</li>
            </ul>
            <button type="button" class="btn-close" @click="$emit('update:errors', null)"></button>
        </div>

        <!-- Alert successo -->
        <div v-if="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
            {{ successMessage }}
            <button type="button" class="btn-close" @click="$emit('update:successMessage', null)"></button>
        </div>

        <form @submit.prevent="submitForm" class="needs-validation">
            <div class="row g-3">

                <div class="col-md-6" v-if="!formData.id">
                    <label class="form-label">Username</label>
                    <input type="text" class="form-control" v-model="formData.username" required>
                </div>

                <div class="col-md-6" v-if="!formData.id">
                </div>


                <div class="col-md-6">
                    <label class="form-label">Nome</label>
                    <input type="text" class="form-control" v-model="formData.name" required>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Cognome</label>
                    <input type="text" class="form-control" v-model="formData.surname" required>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <input type="email" class="form-control" v-model="formData.email">
                    <small v-if="formData.email && !isValidEmail(formData.email)" class="text-danger">Email non
                        valida</small>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Codice Fiscale</label>
                    <input type="text" class="form-control" v-model="formData.fiscalcode">
                    <small v-if="formData.fiscalcode && !isValidFiscalCode(formData.fiscalcode)"
                        class="text-danger">Codice fiscale non valido</small>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Organizzazione</label>
                    <input type="text" class="form-control" v-model="formData.organization">
                </div>

                <div class="col-md-6">
                    <label class="form-label">Partita IVA Organizzazione</label>
                    <input type="text" class="form-control" v-model="formData.organization_fiscal_code">
                    <small v-if="formData.organization_fiscal_code && !isValidPIVA(formData.organization_fiscal_code)"
                        class="text-danger">Partita IVA non valida</small>
                </div>

                <div class="col-md-6">
                    <div class="form-check mt-4">
                        <input class="form-check-input" type="checkbox" id="stazioneAppaltante"
                            :checked="formData.user_type_code === 'S'" :disabled="isEditing"
                            @change="toggleStazioneAppaltante">
                        <label class="form-check-label" for="stazioneAppaltante">
                            Utente stazione appaltante
                        </label>
                    </div>
                </div>

                <div class="col-12 mt-3 d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-secondary" @click="$emit('close')">Annulla</button>
                    <button type="submit" class="btn btn-primary" :disabled="!canSave">Salva</button>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'UserForm',
    props: {
        modelValue: {
            type: Object,
            default: () => ({
                id: null,
                name: '',
                surname: '',
                email: '',
                fiscalcode: '',
                organization: '',
                organization_fiscal_code: '',
                user_type_code: 'B'
            })
        },
        errors: { type: Object, default: null },
        successMessage: { type: String, default: null }
    },
    computed: {
        formData: {
            get() {
                return this.modelValue || {
                    id: null,
                    name: '',
                    username: '',
                    surname: '',
                    email: '',
                    fiscalcode: '',
                    organization: '',
                    organization_fiscal_code: '',
                    user_type_code: 'B'
                };
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        },
        canSave() {
            const basicValid = this.formData.name && this.formData.surname && this.formData.email;
            const usernameValid = !this.isEditing || (this.formData.username && this.formData.username.trim() !== '');

            const emailValid = !this.formData.email || this.isValidEmail(this.formData.email);
            const fiscalValid = !this.formData.fiscalcode || this.isValidFiscalCode(this.formData.fiscalcode);
            const pivaValid = !this.formData.organization_fiscal_code || this.isValidPIVA(this.formData.organization_fiscal_code);

            return basicValid && emailValid && fiscalValid && pivaValid && usernameValid;
        },

        isEditing() {
            return !!this.formData.id;
        }

    },
    methods: {
        toggleStazioneAppaltante(event) {
            this.formData.user_type_code = event.target.checked ? 'S' : 'B';
        },
        submitForm() {
            if (!this.canSave) return;
            this.$emit('save', this.formData);
        },

        isValidEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },

        isValidFiscalCode(cf) {
            const re = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
            return re.test(cf);
        },

        isValidPIVA(piva) {
            const re = /^[0-9]{11}$/;
            return re.test(piva);
        }
    }
}
</script>

<style scoped>
textarea.form-control {
    min-height: 80px;
}
</style>
